import { Epic } from 'redux-observable';
import { ofAction } from 'typescript-fsa-redux-observable-of-action';
import { AnyAction } from 'typescript-fsa';
import moment from 'moment';
import { map } from 'rxjs/operators';
import { asyncActionWithCallback, WrapAction } from 'libs/reduxObservableUtils';
import { from } from 'rxjs';
import { controlInitServices } from 'services/controlInit';
import { AxiosResponse, TResponsePagination } from 'libs/axios';
import { messageModule } from 'modules/message/message.reducer';
import { uiModule } from 'modules/ui/ui.reducer';
import { push } from 'connected-react-router';
import { EPath } from 'constants/routes';
import { TControlInitDetail } from 'types/controlInit';
import { controlInitModule } from './controlInit.reducer';
import actions from './controlInit.action';

export const getControlInitEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.getControlInit),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: controlInitModule.actions.loading(),
        asyncFns: from(controlInitServices.getControlInit(payload)),
        next: (u: TResponsePagination<TControlInitDetail>) => controlInitModule.actions.getListControlInit(u),
        complete: controlInitModule.actions.stopLoading(),
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );

export const createControlInitEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.createControlInit),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: controlInitModule.actions.loading(),
        asyncFns: from(controlInitServices.createControlInit(payload)),
        next: (u: any) => [push(EPath.A10_1), messageModule.actions.setSuccess('')],
        complete: controlInitModule.actions.stopLoading(),
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );

export const updateControlInitEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.updateControlInit),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: controlInitModule.actions.loading(),
        asyncFns: from(controlInitServices.updateControlInit(payload)),
        next: () => [push(EPath.A10_1), messageModule.actions.setSuccess('')],
        complete: controlInitModule.actions.stopLoading(),
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );

export const deleteControlInitEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.deleteControlInit),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: controlInitModule.actions.loading(),
        asyncFns: from(controlInitServices.deleteControlInit(payload)),
        next: (u: number) => [controlInitModule.actions.removeControlInit(u), messageModule.actions.setSuccess('')],
        complete: controlInitModule.actions.stopLoading(),
        error: (err: AxiosResponse) => [controlInitModule.actions.setError(true)],
      }),
    ),
  );

export const getControlInitDetailEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.getControlInitDetail),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: controlInitModule.actions.loading(),
        asyncFns: from(controlInitServices.getControlInitDetail(payload)),
        next: (u: TControlInitDetail) => [controlInitModule.actions.saveControlInitDetail(u)],
        complete: controlInitModule.actions.stopLoading(),
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );

export const uploadControlInitFileEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.uploadControlInitFile),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: uiModule.actions.showLoading(),
        asyncFns: from(controlInitServices.uploadControlInitFile(payload)),
        complete: uiModule.actions.hideLoading(),
        next: (u: { fname: string; originalName: string }) => [controlInitModule.actions.setDataFileUpload(u)],
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );

export const downloadControlInitEpic: Epic<AnyAction, WrapAction<typeof asyncActionWithCallback>> = (action$) =>
  action$.pipe(
    ofAction(actions.downloadControlInitFile),
    map(({ payload }) =>
      asyncActionWithCallback({
        previous: uiModule.actions.showLoading(),
        asyncFns: from(controlInitServices.downloadControlInitFile(payload)),
        complete: uiModule.actions.hideLoading(),
        next: (u: any) => {
          const url = window.URL.createObjectURL(new Blob([`\ufeff${u}`], { type: 'text/csv;charset=utf-8;' }));
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          const currentTime = moment(Date.now()).format('YYYYMMDD');
          a.download = `exemplary_inits_${currentTime}.csv`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          return [];
        },
        error: (err: AxiosResponse) => messageModule.actions.setError(err.data.message),
      }),
    ),
  );
